import type { AppVueRouter } from '@modules/core/services/router/types';
import { AppModule } from '@modules/core/plugins/AppModule';
import {
  ADMIN_PENDING_WITHDRAWALS_ROUTE_NAME,
  PENDING_WITHDRAWALS_PERMISSIONS,
} from '@modules/pending-withdrawals/constants';

import { ADMIN_PENDING_WITHDRAWALS_VIEW_ROUTE_NAME } from './constants';

export class PendingWithdrawalsViewModule extends AppModule {
  addRoutes(router: AppVueRouter): void {
    router.addChildRoute(ADMIN_PENDING_WITHDRAWALS_ROUTE_NAME, {
      name: ADMIN_PENDING_WITHDRAWALS_VIEW_ROUTE_NAME,
      path: 'view/:id',
      component: () => import('./pages/PendingWithdrawalsViewPage/PendingWithdrawalsViewPage.vue'),
      permission: PENDING_WITHDRAWALS_PERMISSIONS.SHOW,
    });
  }

  addMenu(): void {}

  addTranslationKeys(): void {}
}
